/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PostsRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let group = this.modelFor('group');
    let queryParams = { include: 'reactions,comments' };
    queryParams.groupId = group.id;
    queryParams.goalId = params.goal_id;
    let data = {
      posts: this.store.query('posts/post', queryParams),
      // Load the specific goal based on `goal_id`
      currentGoal: this.store.findRecord('goals/goal', params.goal_id),
      group,
    };

    return hash(data);
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    // Set the active tab.
    this.controllerFor('group.topics.topic').set('topicTab', 'posts');
  }
}
